import React from "react";

/**
 * Decorative SVG waveform overlay.
 * Static (non-animated) version used for hero / accents.
 */
export function WaveformDecor({ className = "", color = "#F7F5F0", opacity = 0.6 }) {
  const bars = Array.from({ length: 64 });
  return (
    <svg
      viewBox="0 0 640 80"
      preserveAspectRatio="none"
      className={className}
      aria-hidden="true"
    >
      {bars.map((_, i) => {
        // Pseudo-random-ish but deterministic
        const h = 6 + Math.abs(Math.sin(i * 1.37) * 28) + Math.abs(Math.cos(i * 0.7) * 12);
        return (
          <rect
            key={i}
            x={i * 10}
            y={40 - h / 2}
            width="3"
            height={h}
            fill={color}
            opacity={opacity}
            rx="1.5"
          />
        );
      })}
    </svg>
  );
}

/**
 * Animated waveform for the audio player. `playing` toggles motion.
 */
export function WaveformPlayer({ playing, progress = 0, bars = 56 }) {
  const arr = Array.from({ length: bars });
  return (
    <div className="flex items-end gap-[3px] h-12 w-full relative" data-testid="waveform">
      {arr.map((_, i) => {
        const seed = Math.sin(i * 1.71) * 0.5 + Math.cos(i * 0.43) * 0.3;
        const h = 18 + Math.abs(seed) * 70; // 18 - ~70%
        const filled = (i / bars) * 100 <= progress;
        return (
          <span
            key={i}
            style={{
              height: `${h}%`,
              animationDelay: `${(i % 8) * 0.08}s`,
            }}
            className={`flex-1 rounded-[1px] origin-bottom transition-colors duration-300 ${
              filled ? "bg-brand-ochre" : "bg-brand-charcoal/25"
            } ${playing ? "animate-wave" : ""}`}
          />
        );
      })}
    </div>
  );
}
